export const dictionary = {
  MAIN_PHRASE1: {
    ES: "La manera ",
    EN: "",
  },
  MAIN_PHRASE2: {
    ES: "más simple ",
    EN: "The simplest ",
  },
  MAIN_PHRASE3: {
    ES: "de crear tu tienda online gratis",
    EN: "way to create your online store for free",
  },
  SECONDARY_PHRASE: {
    ES: "Todos tus productos a un clic de tus clientes.",
    EN: "All your products at a click of your customers.",
  },
  HOW_IT_WORK_TITLE: {
    ES: "Descubre cómo podría verse tu tienda",
    EN: "Find out what your store could look like",
  },
  CLOTHES: {
    ES: "Ropa",
    EN: "Clothes",
  },
  CLOTHES_PHRASE: {
    ES: "Exhibe tus prendas de manera profesional y ordenada. Muestra la disponibilidad de talles, colores, texturas, lo que quieras!",
    EN: "Show your products professionally and neatly. Show the availability of sizes, colors, textures, whatever you want!",
  },
  BEAUTY: {
    ES: "Cosmética",
    EN: "Beauty",
  },
  BEAUTY_PHRASE: {
    ES: "Haz que tus productos se luzcan al máximo. Destaca lo nuevo, lo que más vendes o las últimas unidades disponibles.",
    EN: "Make your products shine to the fullest. Highlight what is new, what you sell the most or the last available units.",
  },
  DECO: {
    ES: "Decoración",
    EN: "Decoration",
  },
  DECO_PHRASE: {
    ES: "Enseña todo lo que tienes disponible, con sus medidas, color, variedad de materiales y más para hacer que tu tienda sea única.",
    EN: "Display everything you have available, with its measurements, color, variety of materials and more to make your store unique.",
  },
  BAKERY: {
    ES: "Repostería",
    EN: "Bakery",
  },
  BAKERY_PHRASE: {
    ES: "Tienta a tus clientes con fotos, promociones y productos destacados. Exhibe tus delicias de manera profesional y ordenada.",
    EN: "Tempt your customers with photos, promotions and featured products. Show your delicacies professionally and neatly.",
  },

  DASHBOARD_TITLE: {
    ES: "Ten tu tienda online GRATIS",
    EN: "Have your store for FREE",
  },
  DASHBOARD_SUBTITLE: {
    ES: "Sin costos ni comisiones.",
    EN: "No costs or commissions.",
  },
  ACCOUNT_TITLE: {
    ES: "Cuenta",
    EN: "Account",
  },
  ACCOUNT_SUBTITLE: {
    ES: "Completa los datos de tu cuenta.",
    EN: "Complete your account details.",
  },
  CATEGORIES_TITLE: {
    ES: "Categorías",
    EN: "Categories",
  },
  CATEGORIES_SUBTITLE: {
    ES: "Establece tus categorías.",
    EN: "Set your categories.",
  },
  PRODUCTS_TITLE: {
    ES: "Productos",
    EN: "Products",
  },
  PRODUCTS_SUBTITLE: {
    ES: "Carga tus productos.",
    EN: "Load your products.",
  },

  DISCOVER: {
    ES: "para descubrir como podría quedar tu tienda digital.",
    EN: "to discover what your digital store could look like.",
  },
  SIMPLE_PHRASE: {
    ES: "Más ordenado, más fácil, más ",
    EN: "Tidy , easy , ",
  },

  SELLING: {
    ES: "y exhibe tus productos",
    EN: "and start selling",
  },

  CALL_ACTION_TITLE: {
    ES: "Comienza a utilizar Simple hoy",
    EN: "Get started today",
  },
  CALL_ACTION_SUBTITLE: {
    ES: "Exhibe todos tus productos de manera profesional.",
    EN: "Display all your products in a professional way.",
  },

  WHATSAPP: {
    ES: "Recibe los pedidos por whatsapp",
    EN: "Receive orders by whatsapp",
  },
  WHATSAPP_SUBTITLE: {
    ES: "Activa y desactiva esta opción cuando lo desees.",
    EN: "Turn on and off whenever you want. It will be very useful.",
  },
  DESING: {
    ES: "Personaliza tu tienda",
    EN: "Personalize your store",
  },
  DESING_SUBTITLE: {
    ES: "Elige los colores que más te gusten e identifiquen a tu negocio.",
    EN: "Choose the colors that you like best and identify your business.",
  },
  PHOTO: {
    ES: "Pon hasta 4 fotos por producto",
    EN: "Put up to 4 photos per product",
  },
  PHOTO_SUBTITLE: {
    ES: "No te limites a enseñar sólo una foto del artículo.",
    EN: "Do not limit yourself to showing only a photo of the article.",
  },
  FEATURED: {
    ES: "Destaca productos",
    EN: "Stand out products",
  },
  FEATURED_SUBTITLE: {
    ES: "Haz que llamen la atención determinados productos. Destacalos!",
    EN: "Make certain products stand out. Highlight them!",
  },
  PROMOTION: {
    ES: "Promociona productos",
    EN: "Stand out products",
  },
  PROMOTION_SUBTITLE: {
    ES: "Haz que tus clientes sepan que tienes productos con descuento.",
    EN: "Let your customers know that you have discounted products.",
  },
  PRODUCT: {
    ES: "Exhibe todos tus productos",
    EN: "Display all your products",
  },
  PRODUCT_SUBTITLE: {
    ES: "Enseña tus artículos sin límites en la cantidad. Exhíbelos todos!",
    EN: "Show your articles without limits in quantity. Show them all!",
  },

  FAQ: {
    ES: "Preguntas frecuentes",
    EN: "Frequently asked questions",
  },
  FAQ_SUBTITLE: {
    ES: "Si tienes otra pregunta puedes escribirnos por ",
    EN: "If you have another question you can write us on ",
  },
  EXAMPLES: {
    ES: "Ejemplos",
    EN: "Examples",
  },
  HOW_IT_WORKS: {
    ES: "Cómo funciona",
    EN: "How it works",
  },
  FEATURES: {
    ES: "Funcionalidades",
    EN: "Features",
  },
  FAQ_HEADER: {
    ES: "Preguntas frecuentes",
    EN: "FAQ",
  },
  TRY_IT: {
    ES: "¡ Pruébalo, es gratis !",
    EN: "Try it, it is free!",
  },

  FAQ_1: {
    ES: "¿Qué es Simple?",
    EN: "What is Simple?",
  },
  FAQ_1A: {
    ES: "Simple es una plataforma que te permite crear y gestionar tu tienda para vender online. Cuando un cliente completa su pedido, lo dirigimos a WhatsApp para coordinar entrega y pago. De esta forma la compra finaliza entre negocio y cliente sin intermediarios.",
    EN: "Simple is a platform that allows you to create and manage your store to sell online. When a customer completes their order, we direct them to WhatsApp to coordinate delivery and payment. In this way the purchase ends between the business and the client without intermediaries.",
  },
  FAQ_2: {
    ES: "¿Su uso es gratuito?",
    EN: "Is free?",
  },
  FAQ_2A: {
    ES: "Si, sin costos ni comisiones mensuales.",
    EN: "Yes, without costs or commissions.",
  },
  FAQ_3: {
    ES: "¿Está disponible en mi país?",
    EN: "Is it available in my country?",
  },
  FAQ_3A: {
    ES: "Simple está disponible en idioma español e inglés. Pudiendo establecer como moneda peso, euro o dolar. Si deseas agregar alguna moneda escríbenos por instagram.",
    EN: "Simple is available in Spanish and English. Being able to establish as currency peso, euro or dollar. If you want to add any currency write us on instagram.",
  },
  FAQ_4: {
    ES: "¿Quiénes pueden usar Simple?",
    EN: "Who can use Simple?",
  },
  FAQ_4A: {
    ES: "Todo tipo de comercio. Nuestra plataforma es vérsatil, adaptándose a comercios que ofrecen productos y servicios de los rubros más diversos.",
    EN: "All kinds of business. Our platform is versatile, adapting to businesses that offer products and services from the most diverse areas.",
  },
  FAQ_5: {
    ES: "¿Necesito descargar alguna aplicación?",
    EN: "Do I need to download any application?",
  },
  FAQ_5A: {
    ES: "No, las tiendas Simple funcionan directamente en tu navegador adaptándose a ordenadores, tablets y dispositivos móviles.",
    EN: "No, Simple stores work directly in your browser, adapting to computers, tablets and mobile devices.",
  },
  FAQ_6: {
    ES: "¿Puedo crear mi cuenta desde el móvil?",
    EN: "Can I create my account from my mobile?",
  },
  FAQ_6A: {
    ES: "Sí, puedes crear tu tienda, administrarla y visitarla desde tu ordenador, tablet o teléfono.",
    EN: "Yes, you can create your store, manage it and visit it from your computer, tablet or phone.",
  },
} as const;
